// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"85c66681","455":"d6f1b536","977":"faaf8b8a"}[chunkId] + ".chunk.js";
};